<template>
  <div class="flex flex-col items-center mt-16 bg-[#ECECED]">
    <div class="w-[94%] md:w-[75%] 2xl:w-[60%] py-10">
      <h2 class="text-3xl font-semibold text-mainColor text-center">{{section.name}}</h2>
      <p class="pt-2 text-center md:px-12 pb-5">{{section.description}}</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        <div class="flex flex-row pt-5" v-for="item in items" :key="item.id">
          <div
            class="w-16 h-16 bg-[#F1D5D4] rounded-full flex items-center justify-center shrink-0"
          >
            <img class="w-10 h-10" :src="item.icon" alt="" />
          </div>
          <p class="pl-4">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebaseConfig";
  import {
    collection,
    getDocs,
    query,
    orderBy,
  } from "firebase/firestore";
export default {
  name: "WhyChooseUs",
  data() {
    return {
      items: [],
      mainDocId: null,
        section: {
          name: "",
          description: "",
        },
    };
  },
  mounted() {
    this.fetchMainDoc();
  },
  methods: {
    async fetchMainDoc() {
      const snapshot = await getDocs(collection(db, "whyChooseUs"));
      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        this.mainDocId = docSnap.id;
        this.section = {
          name: docSnap.data().name,
          description: docSnap.data().description,
        };
        this.fetchItems();
      }
    },
    async fetchItems() {
      const q = query(
        collection(db, "whyChooseUs", this.mainDocId, "items"),
        orderBy("orderNumber", "asc")
      );
      const snapshot = await getDocs(q);
      this.items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    },
  }
};
</script>
